<div class="form-group">
    <label class="ui-checkbox input-label">
    <input type="checkbox"
           name="fieldOptions.notvisible" value="{{fieldOptions.notvisible}}"
           [(ngModel)]="fieldOptions.notvisible"
           (ngModelChange)="dataChangedEvent($event)" class="form-control">
    <span><b>Not visible in Grid</b></span>
  </label>
</div>